import Vue from "vue";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
if (process.env.VUE_APP_SENTRY == "true") {
  Raven.config(
    "https://356aa297eb1e4aca91528e5e29fa95b0@sentry.bistunkavir.ir/8"
  )
    .addPlugin(RavenVue, Vue)
    .install();
}

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import "./scripts/bootstrap";

var VueCookie = require("vue-cookie");

import mixin from "./mixin/mixin";

//Kendo
import "@progress/kendo-ui";
import "@progress/kendo-ui/js/kendo.grid";
import "@progress/kendo-theme-default/dist/all.css";
import "@progress/kendo-ui/js/messages/kendo.messages.fa-IR.js";
import directives from "./scripts/directives";

import { Grid, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSourceInstaller } from "@progress/kendo-datasource-vue-wrapper";
Vue.use(GridInstaller);
Vue.use(DataSourceInstaller);

import LiquorTree from "liquor-tree";
Vue.use(LiquorTree);
//End Kendo

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "@/assets/sass/app.scss";
import "@/assets/vendor/style.css";
import "@/assets/vendor/metisMenu/jquery.metisMenu.js";
import "@/assets/vendor/slimscroll/jquery.slimscroll.min.js";
import "@/assets/vendor/base.js";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

// Tell Vue to use the plugin
Vue.use(VueCookie);

import Ibox from "./components/template/Ibox";
import Modal from "./components/template/Modal";
import Map from "./components/template/Map";
import BreadCrumb from "./components/template/BreadCrumb";
import DimButton from "./components/template/buttons/DimButton";
import BlockButton from "./components/template/buttons/BlockButton";
import RoundedButton from "./components/template/buttons/RoundedButton";
import FormButton from "./components/template/buttons/FormButton";
import GGrid from "./components/GGrid";
import BootButton from "./components/template/buttons/BootButton";
import FiltersButton from "./components/template/buttons/FiltersButton";
import FormGroup from "./components/FormGroup";

import Spinner from "./components/Spinner";

Vue.mixin(mixin);

Vue.component("bita-grid", GGrid);
Vue.component("bita-ibox", Ibox);
Vue.component("bita-modal", Modal);
Vue.component("bita-map", Map);
Vue.component("bita-breadcrumb", BreadCrumb);
Vue.component("bita-dbutton", DimButton);
Vue.component("bita-bbutton", BlockButton);
Vue.component("bita-rbutton", RoundedButton);
Vue.component("bita-bootbutton", BootButton);
Vue.component("bita-formbutton", FormButton);
Vue.component("bita-filtersbutton", FiltersButton);
Vue.component("bita-spinner", Spinner);
Vue.component("bita-formgroup", FormGroup);

Vue.config.productionTip = false;
var _that = this;
import acl from "./scripts/acl";
let _acl = new Vue(acl);
Vue.prototype.$acl = _acl;
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = `${to.meta.title} | جت‌ بار`;
  else document.title = `جت بار`;
  return _acl.handleRoutes(to, from, next);
});

// import pkg from "../package.json";
// axios.get("/init").then(({ data }) => {
//   const version = data.panel_version;
//   if (version && version !== pkg.version) {
//     caches.keys().then(function(names) {
//       for (let name of names) caches.delete(name);
//     });
//     location.reload(true);
//   }
// });

new Vue({
  router,
  store,
  directives: directives,
  render: (h) => h(App),
  created() {
    if (localStorage.getItem("token")) {
      this.$store.dispatch("loadLocalUserData");
    }
  },
  components: {
    Grid,
  },
}).$mount("#app");
